import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as errorDiagnosticsDashboard from '@store/errorDiagnostics/dashboard/actions';
import { initTempDashboard } from '@store/errorDiagnostics/tempDashboard/actions';
import { tempDashboardSelector as tempDashboardStateSelector } from '@store/errorDiagnostics/selectors';
import tempDashboardSelector from '@store/errorDiagnostics/tempDashboard/selectors';
import { dashboardResponseSelector, dashboardIsFetchingSelector } from '@store/errorDiagnostics/dashboard/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import ErrorDiagnostics from './ErrorDiagnostics';
import dashboard from '../common/dashboard';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardStateSelector,
  tempDashboardSelector,
  (response, isFetching, dashboardState, tempDashboard) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.ERROR_DIAGNOSTICS,
    dashboard: dashboardState,
    tempIsFetching: tempDashboard.isFetching,
  }),
);

const ErrorDiagnosticsDashboard = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: errorDiagnosticsDashboard.initRequest,
    getDashboard: errorDiagnosticsDashboard.getDashboard,
    fetchingAction: errorDiagnosticsDashboard.fetching,
  }),
  dashboard(),
)(ErrorDiagnostics);

export default ErrorDiagnosticsDashboard;
